interface AtomIconProps {
  size?: number;
}

export function AtomIcon({ size = 28 }: AtomIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    >
      <circle cx="16" cy="16" r="13" opacity="0.5" />
      <ellipse cx="16" cy="16" rx="5" ry="13" />
      <ellipse cx="16" cy="16" rx="5" ry="13" transform="rotate(60 16 16)" />
      <ellipse cx="16" cy="16" rx="5" ry="13" transform="rotate(120 16 16)" />
    </svg>
  );
}
